import Tile from "../Tile/Tile"
import { RecordViewList } from "web/components"
import { useTile } from "web/hooks/data"
import useTileSettingsModal from "web/hooks/data/useTileSettingsModal"
import { TileSummarySettingsModal } from "./TileSummarySettingsModal"

export default function SubjectSummaryTile({
  canEdit = true,
  fieldActions,
  isTemplate,
  overview,
  tileFetchParams,
  isDoubleColumn,
}) {
  const tile = useTile({
    tileFetchParams,
  })

  const tileSettingsModal = useTileSettingsModal({
    isTemplate,
    overview,
    tileSettingsComponent: TileSummarySettingsModal,
    tileTitle: tile.settings_title,
    tileFetchParams,
  })

  async function handleTileSettings() {
    await tileSettingsModal()
  }

  async function handleOnHide() {
    await tile.deleteTile()
  }

  const emptyMessage = "There are currently no summary details to show"

  return (
    <Tile
      handleTileSettings={handleTileSettings}
      handleOnHide={handleOnHide}
      id={tileFetchParams.id}
      title={tile.name}
      canEdit={canEdit}
      breakoutLink={!isTemplate && tile.breakout_link}
    >
      <RecordViewList
        data={tile.data ? [tile.data] : []}
        fields={tile.fields}
        fieldActions={fieldActions}
        emptyMessage={emptyMessage}
        showDummyData={isTemplate}
        isDoubleColumn={isDoubleColumn}
      />
    </Tile>
  )
}
